<template>
  <v-content>
    <Header title="Conveyancing fees">
      <span class="subheading"
        >Choose from the matter types below to get a Conveyancing fees
        quotation</span
      >
    </Header>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm6 md4>
          <v-card height="100%">
            <v-card-title>
              <h2>Sale</h2>
            </v-card-title>
            <v-card-text>Selling a property</v-card-text>
            <v-card-actions>
              <v-btn :to="{ name: 'sale' }">
                <v-icon>input</v-icon>
                <span class="mr-2">Sale</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-card height="100%">
            <v-card-title>
              <h2>Purchase</h2>
            </v-card-title>
            <v-card-text>Purchasing a property</v-card-text>
            <v-card-actions>
              <v-btn :to="{ name: 'purchase' }">
                <v-icon>input</v-icon>
                <span class="mr-2">Purchase</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-card height="100%">
            <v-card-title>
              <h2>Sale and Purchase</h2>
            </v-card-title>
            <v-card-text
              >Moving house or selling and buying a property at the same
              time</v-card-text
            >
            <v-card-actions>
              <v-btn :to="{ name: 'saleAndPurchase' }">
                <v-icon>input</v-icon>
                <span class="mr-2">Sale and purchase</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-card height="100%">
            <v-card-title>
              <h2>Mortgage</h2>
            </v-card-title>
            <v-card-text>(Re)Mortgaging a property</v-card-text>
            <v-card-actions>
              <v-btn :to="{ name: 'mortgage' }">
                <v-icon>input</v-icon>
                <span class="mr-2">Mortgage</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-card height="100%">
            <v-card-title>
              <h2>Transfer of equity</h2>
            </v-card-title>
            <v-card-text>Transferring equity of a property</v-card-text>
            <v-card-actions>
              <v-btn :to="{ name: 'transfer' }">
                <v-icon>input</v-icon>
                <span class="mr-2">Transfer</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 sm6 md4>
          <v-card height="100%">
            <v-card-title>
              <h2>Lease extension</h2>
            </v-card-title>
            <v-card-text>Extending a lease</v-card-text>
            <v-card-actions>
              <v-btn :to="{ name: 'lease' }">
                <v-icon>input</v-icon>
                <span class="mr-2">Lease extension</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="recentQuotes">
          <v-card>
            <v-card-title>
              <h2>Recent quotes</h2>
            </v-card-title>
            <v-card-text
              >You have {{ recentQuotes.length }} recent quotes</v-card-text
            >
            <v-card-actions>
              <v-btn :to="{ name: 'recentQuotes' }">
                <v-icon>input</v-icon>
                <span class="mr-2">Recent quotes</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import Header from "@/components/Header";
import nbmlaw from "@/apis/nbmlaw";
import cookie from "@/components/cookie.js";
export default {
  name: "Fees",
  components: { Header },
  mixins: [cookie],
  data() {
    return {
      recentQuotes: null,
      gradient: "135deg, orange, orange 60%, cyan"
    };
  },
  methods: {
    async fetchRecentQuotes() {
      try {
        const response = await nbmlaw.get("/cors/open/sales/recent", {
          params: { salesUid: this.$cookies.get("salesUid") }
        });
        // console.log(response.data);
        this.recentQuotes = response.data;
      } catch (err) {
        console.error(err);
      }
    }
  },
  created() {
    this.fetchCookie();
    this.fetchRecentQuotes();
  }
};
</script>

<style></style>